import { createAsyncThunk } from '@reduxjs/toolkit';
import request from '../../request/request';

export const getImpersonateDetailAction = createAsyncThunk('impersonateDetail', async (object, { rejectWithValue }) => {
  const response = await request(`/api/v1/auth/start-impersonate/${object.portalName}/${object.tenantId}/${object.userId}`, { method: 'GET' , auth: true});

  if (response?.success) {
    return response;
  }
  const { error } = response;
  throw rejectWithValue(error || 'Something went wrong');
});